import styled from 'styled-components/macro';

import Row from 'components/data-visualization/Table/Row';
import Cell from 'components/data-visualization/Table/Cell';
import EntityItem from 'components/base/EntityItem/EntityItem';
import { ArtworkWrapper } from 'components/base/EntityItem/EntityItem.style';

import { definitionValue } from 'styles/base-classes';
import modularScale from 'styles/helpers/modular-scale';

export const StyledEntityItem = styled(EntityItem)`
  padding: ${({ theme }) => theme.spacing.small} 0 0;

  @media screen and (min-width: 50em) {
    padding: ${({ theme }) => theme.spacing.small} 0;
  }

  &:active,
  &:hover {
    background: none;
  }
`;

export const CellContent = styled('div')`
  ${definitionValue};
  font-weight: 400;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  flex: 1 1 auto;

  @media screen and (min-width: 50em) {
    justify-content: flex-end;
  }
`;

export const EntityCell = styled(Cell)<any>`
  display: block;
  width: 100%;

  &:first-of-type {
    flex-basis: 100%;
    padding: 0;

    ${CellContent} {
      justify-content: flex-start;
    }
  }

  &:last-of-type {
    margin-right: 0;
    flex-basis: 100%;
  }

  &:first-child:last-child {
    padding-bottom: ${({ theme }) => theme.spacing.small};
  }

  @media screen and (min-width: 50em) {
    display: table-cell;

    &,
    &:first-of-type {
      padding-top: 0;
      padding-bottom: 0;
    }

    &:first-of-type {
      width: ${({ twoCols }): string => (twoCols ? '100%' : '60%')};
    }

    &:first-child:last-child {
      padding-bottom: 0;
    }
  }
`;

interface ICustomTableRow {
  isHighlighted?: boolean;
  enableHover?: boolean;
}

export const TableRow = styled(Row)<ICustomTableRow>`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.LightGrey};

  td:not(:first-of-type) {
    font-size: ${modularScale(-1)};
  }

  background: ${({ isHighlighted, theme }): string | false | undefined =>
    isHighlighted && `${theme.Sand}`};

  ${ArtworkWrapper} {
    transform: ${({ isHighlighted }): string | false | undefined =>
      isHighlighted && 'translateX(0.25em)'};
  }

  @media screen and (min-width: 50em) {
    display: table-row;
    border-bottom: 0;

    td {
      border-bottom: 1px solid ${({ theme }) => theme.LightGrey};
    }
  }
`;

export const ValueWrapper = styled.div<any>`
  margin-right: 0.5em;
  text-align: ${({ newDesign }): string => (newDesign ? 'end' : 'center')};
  text-transform: uppercase;
  font-size: 14px;
  min-width: 5.8em;
  ${({ newDesign }): string => (newDesign ? 'padding-right: 2em;' : '')}
  color: ${({ isPositive, theme }): string =>
    isPositive === null
      ? 'inherit'
      : isPositive
      ? theme.PositiveChange
      : theme.NegativeChange};
`;
